/**
 * Types of toggle button appearance.
 * @public
 */
export {
    ButtonAppearance,
    ButtonAppearanceVariant
} from '../patterns/button/types';
